import React from 'react'
import PropTypes from 'prop-types'
import i18n from '@pureartisan/simple-i18n'
import { FiLinkedin } from 'react-icons/fi'
import clsx from 'clsx'

import useStore from './../store'
import {
  onLinkedInShare,
  constructShareLink,
} from './Share'
import { IconButton } from '@material-ui/core'

const LinkedInShareBtn = ({ children, ...props }) => {
  // Generic store value setter.
  const shareHash = useStore(state => state.shareHash)
  const handleShare = () => {
    onLinkedInShare(
      encodeURIComponent(constructShareLink(shareHash))
    )
    // setStoreValues({
    //   eventShareLinkedIn: eventShareLinkedIn + 1,
    // })
  }

  return (
    <div
      onClick={handleShare}
      className={clsx(props.className)}
    >
      <IconButton
        label={i18n.translate(`BUTTON_SHARE_LINKEDIN`)}
      >
        <FiLinkedin className="social-icon" />
        <span className="sr-only">
          {i18n.translate(`BUTTON_SHARE_LINKEDIN`)}
        </span>
      </IconButton>
      {children}
    </div>
  )
}

export default LinkedInShareBtn
